import type { ApiBaseResponse } from '@module/apis/type';
import convertFormData from '@module/utils/convertFormData';
import { getFormData } from '@module/utils/getFormData';
import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type {
  BoardListParams,
  BoardListResponse,
  FetchBoardDetailParams,
  FetchBoardDetailResponse,
  FetchFaqParams,
  FetchFaqResponse,
  FetchInquireDeleteParams,
  FetchInquireDeleteResponse,
  FetchInquireListParams,
  FetchInquireListResponse,
  FetchInquireModifyParams,
  FetchInquireWriteParams,
  FetchInquireWriteResponse,
} from './type';

export const fetchFaq = async (params: FetchFaqParams) => {
  const res = await fetchExtended(`/v1/bbs/faq`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as FetchFaqResponse;
};

export const fetchBoardList = async (params: BoardListParams) => {
  const res = await fetchExtended(`/v1/bbs`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as BoardListResponse;
};

export const fetchBoardDetail = async (params: FetchBoardDetailParams) => {
  const res = await fetchExtended(`/v1/bbs/view`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as FetchBoardDetailResponse;
};

export const fetchInquireList = async (params: FetchInquireListParams) => {
  const res = await fetchExtended(`/v1/bbs/qna`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as FetchInquireListResponse;
};

export const fetchInquireWrite = async (params: FetchInquireWriteParams) => {
  const res = await fetchExtended(`/v1/bbs/qna/write`, {
    method: 'POST',
    credentials: 'include',
    body: getFormData(params),
  });

  const result = await res.json();

  return result as FetchInquireWriteResponse;
};

export const fetchInquireModify = async (params: FetchInquireModifyParams) => {
  const res = await fetchExtended(`/v1/bbs/qna/modify`, {
    method: 'POST',
    credentials: 'include',
    body: getFormData(params),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchInquireDelete = async (params: FetchInquireDeleteParams) => {
  const res = await fetchExtended(`/v1/bbs/qna/delete`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as FetchInquireDeleteResponse;
};
